import { FC, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import config from '../../../../lib/config';
import FileUpload from "../../../FileUpload";
import styled from 'styled-components';

const Block = styled.div`
  .img-preview {
    max-width: 400px;
    margin-top: 5px;
  }
`;

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  isMobile: boolean;
  file: File|undefined;
  setFile: (file: File) => void;
}

const UploadImageModal: FC<IProps> = ({
  visible, setVisible, isMobile, file, setFile
}) => {
  const { t } = useTranslation();
  const [imgBase64, setImgBase64] = useState('');
  const [width, setWidth] = useState<number|undefined>();
  const [height, setHeight] = useState<number|undefined>();

  const onSetFile = (file: File) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      if (base64) {
        setImgBase64(base64.toString());
        const img = new Image();
        img.src = base64.toString();
        img.onload = () => {
          setWidth(img.width);
          setHeight(img.height);
        }
      }
    }
    reader.readAsDataURL(file);
    setFile(file);
  }

  return (
    <Modal
      title={`${t('homepage.mainBanner.title4')} ${isMobile ? (`${t('homepage.mainBanner.title5')}`) : '(PC)'}`}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="cancel"
            className='btn-basic pink'
            onClick={() => setVisible(false)}
          >
            {t('common.button.confirm')}
          </AntButton>       
        </div>
      ]}
    >
      <Block className="text-center">
        <div>
          {t('homepage.mainBanner.text3')}
          {t('homepage.mainBanner.text4')} {isMobile ? config.mobileMainBannerWidth : config.mainBannerWidth}px,
          {t('homepage.mainBanner.text5')} {isMobile ? config.mobileMainBannerHeight : config.mainBannerHeight}px {t('homepage.mainBanner.text6')}
          {
            imgBase64
              ? <img className="img-preview" src={imgBase64} alt="preview" />
              : null
          }
        </div>
        <div className="flex justify-content-center">
          <div className="mt-3">
            <FileUpload
              file={file}
              setFile={onSetFile}
            />
          </div>
          <div>
            {
              width && height
                ? `${t('homepage.mainBanner.text7')}: ${t('homepage.mainBanner.text4')} ${width}px, ${t('homepage.mainBanner.text5')} ${height}px`
                : null
            }
          </div>
        </div>
      </Block>
    </Modal>
  );
}

export default UploadImageModal;
